import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../../DatePicker';
import { FilterTypes } from '../Components';
import { formatDate, convertDateToISO } from '../../Utils/dateHelper';

class DatePickerFilter extends Component {
  constructor(props) {
    super(props);

    this.refDatepicker = createRef();
  }

  handleChange = (date) => {
    const { item } = this.props;

    if (date == null) {
      return;
    }

    this.refDatepicker.clear();

    this.notifyAddFilter(
      item.propertyName,
      item.queryOption,
      {
        target: {
          name: item.description,
          displayValue: date ? formatDate(date.getDate(), date.getMonth() + 1, date.getFullYear(), '/') : '',
          value: convertDateToISO(date),
        },
      },
      null,
      null,
      FilterTypes.DATEPICKER,
      item.customFilter,
    );
  };

  notifyAddFilter = (...filter) => {
    const { addFilter } = this.props;

    addFilter && addFilter(...filter);
  };

  render() {
    const {
      item,
      ...others
    } = this.props;

    return (
      <div
        className="filter__campoRicerca"
        style={item.width && { width: item.width.toString() }}
      >
        <DatePicker
          onChange={this.handleChange}
          ref={(r) => { this.refDatepicker = r; }}
          title={item.description}
          {...others}
        />
      </div>
    );
  }
}

DatePickerFilter.propTypes = {
  /** Callback invocata all'aggiunta di un termine di filtro */
  addFilter: PropTypes.func.isRequired,
  /** Descrittore del filtro da applicare */
  item: PropTypes.shape({
    propertyName: PropTypes.string.isRequired,
    queryOption: PropTypes.number,
    description: PropTypes.string,
    width: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
    customFilter: PropTypes.array,
  }).isRequired,
};

export default DatePickerFilter;
